import { useState, useEffect, useContext } from "react"
import { FirebaseContext } from "../firebase"
import { UserContext } from "../context/userContext"
import { onSnapshot, doc } from "firebase/firestore"

const useTwoFactorDeadlineMet = () => {
  const [deadlinesMet, setDeadlinesMet] = useState({}) // Object to track deadlines per enterprise
  const firebase = useContext(FirebaseContext)
  const userCtx = useContext(UserContext)

  useEffect(() => {
    if (!userCtx?.session?.enterprise_list?.length) return

    const unsubscribers = []

    userCtx.session.enterprise_list.forEach((enterpriseRef) => {
      const featureDocRef = doc(firebase.db, `${enterpriseRef.path}/features/1`)

      const unsubscribe = onSnapshot(
        featureDocRef,
        (featureDocSnap) => {
          if (featureDocSnap.exists()) {
            const featureData = featureDocSnap.data()
            const config = featureData?.config
            const enable = featureData?.enable // Extract the enable flag

            if (enable) {
              // Only process if enable is true
              const activation_date = config?.activation_date
              const deadline_days = config?.deadline_days

              if (activation_date && deadline_days) {
                const activationDate = activation_date.toDate()
                const deadlineDate = new Date(
                  activationDate.getTime() + deadline_days * 24 * 60 * 60 * 1000
                )

                setDeadlinesMet((prev) => {
                  const newState = {
                    ...prev,
                    [enterpriseRef.id]: new Date() > deadlineDate, // Store deadline status per enterprise
                  }

                  return newState
                })
              }
            }
          }
        },
        (error) => {
          console.error("Error fetching feature data:", error)
        }
      )

      unsubscribers.push(unsubscribe)
    })

    return () => {
      unsubscribers.forEach((unsub) => unsub())
    }
  }, [firebase.db, userCtx.session.enterprise_list])

  const isAnyDeadlineMet = Object.values(deadlinesMet).some(Boolean) // Compute overall state
  return isAnyDeadlineMet
}

export default useTwoFactorDeadlineMet
